import GcCounter from "../../../../src/components/GcCounter";
import * as React from 'react';
export default {
  GcCounter,
  React
};